import { createSlice } from "@reduxjs/toolkit";
import { paymentLinkGenerateType } from "../../../types/paymentType";

const initalState: paymentLinkGenerateType = { link: "", app: "", upiId: "" };

const linkSlice = createSlice({
  name: "link",
  initialState: initalState,
  reducers: {
    updatePaymentLink: (state, action) => {
      state.link = action.payload.link;
      state.app = action.payload.app;
      state.upiId = action.payload.upiId;
    },
    resetPaymentLink: (state) => {
      state.link = "";
      state.app = "";
      state.upiId = "";
    },
  },
});

export const { updatePaymentLink, resetPaymentLink } = linkSlice.actions;
export default linkSlice.reducer;
